/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
<transition  appear>
  <div class="logo-wrapper">
<h1>

  <em>A</em>
  <em>V</em>
  <em>I</em>
  <em>S</em>
  <em class="planet left"></em>
  <em>L</em>
  <em>A</em>
  <em>R</em>
</h1>
</div>
</transition>
</template>

<script>

export default {
  mounted: function () {
    setTimeout(() => {
      this.$router.push({'name': 'home'})
    }, 4000)

    document.getElementsByTagName('html')[0].setAttribute('class', 'htm')
    document.getElementsByTagName('body')[0].setAttribute('class', 'bod')
  }
}
</script>

<style>
.htm {
  margin: 0;
  height: 100%;
  overflow-y:hidden;
}

.bod {
  margin: 0;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('https://s3.ap-south-1.amazonaws.com/scada4xapp/assets/images/bk_splash.jpeg');
  color: #ccc;
}
</style>
<style>

h1 {
  margin: 0;
  height: 12vmin;
  width: 120vmin;
  display: flex;
  justify-content: center;
  position: relative;
  margin-left: -3vmin;
}

h1::before {
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  top: -15vmin;
  left: 63vmin;
  width: 34vmin;
  height: 34vmin;
  border-radius: 50%;
  border: 1.3vmin solid currentColor;
  box-sizing: border-box;
}

em {
  font-family: 'Josefin Sans', sans-serif;
  color: currentColor;
  font-size: 7vmin;
  position: relative;
  font-style: normal;
  width: 8vmin;
  text-align: center;
}

em.planet {
  -webkit-animation: planet-rotate 4s linear infinite;
  animation: planet-rotate 4s linear infinite;
  position: relative;
}

em.planet::before {
  content: "";
  position: absolute;
  top: -.5vmin;
  /* left: 3.5vmin; */
  left:1.5vmin;
  z-index: -1;
  width: 8vmin;
  height: 8vmin;
  /* border-radius: 50%; */
  border-radius: 150px;
  /* background: black; */
  background:#ccc;
}

em.planet.left {
  -webkit-transform-origin: 40vmin 5vmin;
  transform-origin: 22vmin 1vmin;
}

@-webkit-keyframes planet-rotate {
  to {
    -webkit-transform: rotate(1turn);
  }
}

@keyframes planet-rotate {
  to {
    transform: rotate(1turn);
  }
}
@media(max-width: 800px) {
    .h1::before{
        left:52vmin;
    }
  }

</style>
